// Step de Boas-vindas do onboarding
import { Sparkles } from 'lucide-react';
import { Button } from '../common/Button';

interface WelcomeStepProps {
  onNext: () => void;
}

export function WelcomeStep({ onNext }: WelcomeStepProps) {
  return (
    <div className="text-center space-y-6 py-8">
      <div className="w-20 h-20 bg-gradient-to-br from-primary-500 to-primary-700 rounded-full flex items-center justify-center mx-auto shadow-lg shadow-primary-500/30">
        <Sparkles className="w-10 h-10 text-white" />
      </div>

      <div className="space-y-3">
        <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
          Bem-vindo ao proNotas!
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-400 max-w-md mx-auto">
          Vamos configurar sua empresa para começar a usar o sistema. Este processo levará apenas alguns minutos.
        </p>
      </div>

      <div className="pt-4">
        <Button variant="primary" size="lg" onClick={onNext} className="px-8">
          Começar Configuração
        </Button>
      </div>
    </div>
  );
}
